var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItem1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9396 18.2877C55.9396 16.5053 54.4947 15.0604 52.7123 15.0604H47.3335V5.37843C47.3335 3.5961 45.8885 2.15112 44.1062 2.15112H26.8938C25.1115 2.15112 23.6665 3.5961 23.6665 5.37843V15.0604H18.2877C16.5053 15.0604 15.0604 16.5053 15.0604 18.2877V38.7275H55.9396V18.2877ZM40.8789 15.0604H30.1212V8.60575H40.8789V15.0604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1667 45.1821H55.9396H15.0604H11.8333C5.30828 45.1821 0 50.4906 0 57.0156C0 63.5406 5.30828 68.8489 11.8333 68.8489H59.1667C65.6915 68.8489 71 63.5406 71 57.0156C71 50.4906 65.6915 45.1821 59.1667 45.1821ZM59.1667 62.3942H11.8333C8.86758 62.3942 6.45462 59.9813 6.45462 57.0156C6.45462 54.0497 8.86758 51.6368 11.8333 51.6368H59.1667C62.1324 51.6368 64.5454 54.0497 64.5454 57.0156C64.5454 59.9813 62.1324 62.3942 59.1667 62.3942Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem1);
export default __webpack_public_path__ + "static/media/item1.9a95a3d361c2dc09e4449bc71ebf54c8.svg";
export { ForwardRef as ReactComponent };